module.exports = __webpack_public_path__ + "static/img/辦公環境_2025.779fffe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/employee-care/辦公環境_2025.jpg
// module id = n6/u
// module chunks = 100